import React, { useCallback, useMemo } from "react";

import { TakeoffSurface } from "@skydio/pbtypes/pbtypes/gen/dock_client/takeoff_surface_pb";

import MultiSelectFilter from "./MultiSelectFilter";

import type { FC } from "react";
import type { ValueType } from "@skydio/core";
import type { BaseProps } from "./SelectFilter";

type ReadableDockType = {
  readableName: string;
  enumValue: string | ValueType<TakeoffSurface.EnumMap>;
  enumStringName: string;
};

interface Props extends BaseProps {
  placeholder: string;
  onSelect: (value: string[]) => void;
  selectedValues?: string[] | undefined;
  convertParamVariable?: (dockTypes: string) => string[];
  disabled?: boolean;
}

const getTypes = () =>
  Object.entries(TakeoffSurface.Enum).map(
    ([key, value]) =>
      ({
        readableName: value,
        enumValue: value,
        enumStringName: key,
      }) as ReadableDockType
  );

const MultiDockTypeFilter: FC<Props> = ({
  onSelect,
  convertParamVariable,
  placeholder,
  className,
  style,
  paramKey,
  disabled = false,
  selectedValues = undefined,
}) => {
  const data = useMemo(() => getTypes(), []);
  const getKey = useCallback((dockType: ReadableDockType) => dockType.enumStringName, []);
  const getValue = useCallback((dockType: ReadableDockType) => dockType.enumStringName, []);
  const getTitle = useCallback((dockType: ReadableDockType) => dockType.enumStringName, []);

  return (
    <MultiSelectFilter<ReadableDockType, string>
      onSelect={onSelect}
      className={className}
      style={style}
      disabled={disabled}
      placeholder={placeholder}
      data={data}
      paramKey={paramKey}
      getKey={getKey}
      getValue={getValue}
      getTitle={getTitle}
      convertParamVariable={convertParamVariable}
      showSearch={false}
      setValue={selectedValues}
    />
  );
};

export default MultiDockTypeFilter;
